export default __webpack_public_path__ + "static/media/banner-bg-ir-prev-2025.4aa26d5f.jpg";